var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../PythonCodeInput.js';
let PythonCodeNodeInput = class PythonCodeNodeInput extends LitElement {
    onCodeChanged(event) {
        this.input.value = event.detail;
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { key: this.key, input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <python-code-input
                .code=${this.input?.value || ''}
                @code-changed=${this.onCodeChanged}
            ></python-code-input>
        `;
    }
};
PythonCodeNodeInput.styles = css `
      :host {
        display: block;
        width: 100%;
      }
    `;
__decorate([
    property({ type: String })
], PythonCodeNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], PythonCodeNodeInput.prototype, "input", void 0);
PythonCodeNodeInput = __decorate([
    customElement('python-code-node-input')
], PythonCodeNodeInput);
export { PythonCodeNodeInput };
//# sourceMappingURL=PythonCodeNodeInput.js.map